import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

import norwayy1 from '../images/norwayy1.jpeg';
import norwayy2 from '../images/norwayy2.jpeg';
import norwayy3 from '../images/norwayy3.jpeg';
import norwayy4 from '../images/norwayy4.jpeg';
import norwayy5 from '../images/norwayy5.jpeg';
import norwayy6 from '../images/norwayy6.jpeg';
import norwayy7 from '../images/norwayy7.jpeg';
import norwayy8 from '../images/norwayy8.jpeg';
import norwayy9 from '../images/norwayy9.jpeg';
import norwayy10 from '../images/norwayy10.jpeg';
import norwayy11 from '../images/norwayy11.jpeg';
import norwayy12 from '../images/norwayy12.jpeg';
import norwayy13 from '../images/norwayy13.jpeg';
import norwayy14 from '../images/norwayy14.jpeg';
import norwayy15 from '../images/norwayy15.jpeg';
import norwayy16 from '../images/norwayy16.jpeg';
import norwayy17 from '../images/norwayy17.jpeg';
import norwayy18 from '../images/norwayy18.jpeg';
import norwayy19 from '../images/norwayy19.jpeg';
import norwayy20 from '../images/norwayy20.jpeg';
import norwayy21 from '../images/norwayy21.jpeg';
import norwayy22 from '../images/norwayy22.jpeg';
import norwayy23 from '../images/norwayy23.jpeg';

function Norwayy() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images - norwayy1 through norwayy23
  const photos = [
    norwayy1, norwayy2, norwayy3, norwayy4, norwayy5, norwayy6, norwayy7, norwayy8, norwayy9, norwayy10,
    norwayy11, norwayy12, norwayy13, norwayy14, norwayy15, norwayy16, norwayy17, norwayy18, norwayy19, norwayy20,
    norwayy21, norwayy22, norwayy23
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇳🇴 Norway 2025 🇳🇴</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Norway ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Norwayy;